module.exports = {
    ...require('./advancedConfiguration.verifyContract'),
    ...require('./constructor.verifyContract'),
    ...require('./library.verifyContract'),
    ...require('./success.verifyContract'),
    ...require('./fail.verifyContract'),
    ...require('./similarContract.verifyContract'),
    ...require('./verifiedContract.verifyContract'),
    ...require('./title.verifyContract')
}
